import './Checkout.scss';

import { Form, Formik } from 'formik';
import React from 'react';

import { ROUTE_SCANBAT } from '@/common/constants';
import Aside from '@/ebat/components/blocks/Scanbat/Checkout/Aside/Aside';
import Content from '@/ebat/components/blocks/Scanbat/Checkout/Content/Content';
import Header from '@/ebat/components/blocks/Scanbat/Common/Header/Header';
import useManageCarts from '@/ebat/hooks/carts/useManageCarts';

import { CheckoutDefaultProps, CheckoutPropTypes } from './Checkout.proptypes';
import useCheckout from './useCheckout';

const Checkout = ({
  cart,
  company,
  disabled,
  isLoading,
  refetchCart,
  warehouse,
}) => {
  const { isDisabled: isDisabledUseManageCarts, localCart } = useManageCarts({
    cart,
    disabled,
    isLoading,
    refetchCart,
  });
  const {
    initialValues,
    isDisabled,
    onRemoveWarehouse,
    onSubmit,
    validationSchema,
  } = useCheckout({
    disabled: disabled || isDisabledUseManageCarts.disabled,
    isLoading: isLoading || isDisabledUseManageCarts.loading,
    localCart,
    warehouse,
  });

  return (
    <div className="wrapper wrapper--full">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => onSubmit(values, actions)}
      >
        {() => (
          <Form className="form" data-qa-id="checkout-form">
            <Header
              className="scanbat-checkout-page__header"
              company={company}
              disabled={isDisabled.disabled}
              link={ROUTE_SCANBAT}
              onRemoveWarehouse={onRemoveWarehouse}
              warehouse={warehouse}
            />
            <Content
              cart={localCart}
              className="scanbat-checkout-page__content"
              disabled={isDisabled.disabled}
              isLoading={isDisabled.loading}
            />
            <Aside
              cart={localCart}
              className="scanbat-checkout-page__aside"
              currentItems={localCart.items}
              disabled={isDisabled.disabled}
              isLoading={isDisabled.loading}
              refetchCart={refetchCart}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

Checkout.defaultProps = {
  ...CheckoutDefaultProps,
};

Checkout.propTypes = {
  ...CheckoutPropTypes,
};

export default Checkout;
